import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "DomainVerificationChannel" },
      { received: (data) => this.handleMessage(data) }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
    this.consumer?.disconnect()
  }

  handleMessage(data) {
    if (data.has_org) {
      window.location.href = "/"
    } else {
      // Reload the page to show updated domain card status
      window.location.reload()
    }
  }
}
